var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"background",style:('background-image: linear-gradient(rgba(51, 51, 51, 0.75), rgb(51, 51, 51)), url(' + _vm.image + ')')},[_vm._v("\n   \n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }